const useGlobalStyles = () => {
  return {
    deactivatedText: {
      opacity: 0.5,
    } as React.CSSProperties,
  };
};

export default useGlobalStyles;
